// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: Usermanual.js
// Description: This file is responsible to show User Manual
//
// ************************************************************************************************************************************************************
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Avatar,
} from "@material-ui/core";
import { Divider } from "@material-ui/core";
import Email from "../../../icons/Email.svg";
import Guide from "../../../icons/Guide.svg";
import Phone from "../../../icons/Phone.svg";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React from "react";
import * as Actions from "../redux/action";
import HelpIcon from "../../../icons/HelpIcon.png";
import { Version } from "../../../Application_Constants";


function Usermanual(props) {
  props.searchBarChange(false);
  const  onResumeClick =() => {
    window.open(process.env.REACT_APP_USER_GUIDE);
  }
  return (
    <div>
      <h1 className="text-Heading">
        <img src={HelpIcon} alt="HelpIcon"></img> <span>Help</span>
      </h1>
      <Divider></Divider>
      <AppBar
        position="static"
        style={{
          backgroundColor: "#ffffff",
          padding: "0 0 0 0",
          marginTop: "3px"
        }}
      >
        <Toolbar>
          <IconButton></IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              flexGrow: 1,
              display: { xs: "none", sm: "block" }
            }}
            style={{
              color: "#145898",
              fontWeight: "700",
              fontSize: "18px"
            }}
          ></Typography>
        </Toolbar>
      </AppBar>
      <div
      className="usermanual-div"
        style={{
          paddingTop: "50px",
          paddingLeft: "50px",
          paddingBottom: "60px",
          textAlign: "center"
        }}
      >
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{
            flexGrow: 1,
            display: { xs: "none", sm: "block" }
          }}
          style={{
            paddingRight: "215px",
            fontFamily: "Noto Sans Display",
            fontSize: "20px"
          }}
        >
          What can we help you with?
        </Typography>
        <div
          style={{
            display: "inline-grid",
            textAlign: "initial"
          }}
        >
          <div style={{ paddingTop: "40px", display: "inline-table" }}>
            <Card
              sx={{ borderRadius: "16px", Width: "100px", marginRight: "20px" }}
              style={{ marginRight: "5em" }}
            >
              <CardContent
                sx={{
                  marginRight: "20px"
                }}
              >
                <CardHeader
                  onClick={onResumeClick}
                  avatar={
                    <Avatar aria-label="recipe" style={{ marginTop: "7px", cursor: "pointer" }}>
                      <img src={Guide} alt="Guide" />
                    </Avatar>
                  }
                  title={
                    <Typography
                      variant="h6"
                      font-famaly=""
                      style={{ paddingTop: "10px", fontWeight: "400" , fontFamily: "Noto Sans Display", color: "#313233", cursor: "pointer"}}
                    >
                      GEMflow User Guide
                    </Typography>
                  }
                />
              </CardContent>
            </Card>
          </div>
          <div style={{ paddingTop: "20px", display: "inline-table",fontFamily: "Noto Sans Display"}}>
            <Card sx={{ borderRadius: "16px", Width: "100px" }}>
              <CardContent>
                <CardHeader
                  avatar={
                    <Avatar aria-label="recipe">
                      <img src={Phone} alt="Phone" />
                    </Avatar>
                  }
                  title="Talk to customer service"
                  subheader="1-800-510-3318"
                />
              </CardContent>
            </Card>
          </div>
          <div style={{ paddingTop: "20px", display: "inline-table" }}>
            <Card sx={{ borderRadius: "16px", Width: "100px" }}>
              <CardContent>
                <CardHeader
                  avatar={
                    <Avatar aria-label="recipe">
                      <a href="mailto:gemflow-support@baxter.com"><img src={Email} alt="Email" style={{ height: "20px"}} /></a>
                    </Avatar>
                  }
                  title="Send us an email"
                  subheader={
                    <Typography>
                      <a href="mailto:gemflow-support@baxter.com" style={{ color: "#158380" , fontFamily: "Noto Sans Display"}}>gemflow-support@baxter.com</a>
                    </Typography>
                  }
                />
              </CardContent>
            </Card>
          </div>
        </div>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{
            flexGrow: 1,
            display: { xs: "none", sm: "block" }
          }}
          style={{
            paddingRight: "160px",
            fontFamily: "Noto Sans Display",
            fontSize: "20px",
            paddingTop: "110px"
          }}
        >
          Version {Version}
        </Typography>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userManual: state.userManual,
    selectedTab: state.selectedTab
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeMenu: Actions.changeSideBar,
      searchBarChange: Actions.changeSearchBar
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Usermanual);
